import React from 'react';
import { Card } from 'react-bootstrap';
import projImg2 from "../../assets/img/2.png";
import projectimage2 from "../../assets/img/p2.png";
import ShowMoreText from "react-show-more-text";


// Begin: Component code
const PreviousCard2 = () => {
    // Your component logic here
    return (
      <Card className="CARD2" bg="dark">
      {/* <Card.Title><h2>Analyzing the competition in the Hungarian fuel market</h2></Card.Title> */}

      <Card.Img variant="top" src={projectimage2} />

      <Card.Body>
        <Card.Text>
          {" "}
          <img className="img2" src={projImg2} />{" "}
          <p className="text7">Zombor Berezvai </p>
          <br />
          <p className="text8">
            Head of Economic and Market Research
            <br /> Hungarian Competition Authority
          </p>
          {/*  <p className="text7">Supervisor:Dr. Mihály Szabó </p><br/>
       <p className="text7">Rector's delegate. Rector's Office Directorate of Education, BME </p> */}
          {/* <img className="img2" src={projImg21}/> */}
        </Card.Text>
        <ShowMoreText lines={1}>
          <div>
            The aim of the research is to investigate the competitive
            processes in the Hungarian retail fuel market, what
            determines the prices at which certain petrol stations sell
            fuel (e.g. the number of other petrol stations nearby, the
            population of the settlement, the number of petrol stations
            on the motorway). The topicality of the topic is given by
            the fuel price freeze, which was lifted in December 2022
            after more than a year, as it is an interesting question to
            examine the competition in the reviving market. The data for
            the analysis can be obtained from https://holtankoljak.net/,
            which is also part of the exercise.
            <br />
            <br />
            Recommended literature:{" "}
            <ul>
              <li>
                Fasoula, E., & Schweikert, K. (2020). Price regulations
                and price adjustment dynamics: Evidence from the
                Austrian retail fuel market.
                <span className="text9">
                  {" "}
                  Journal of Transport Economics and Policy (JTEP)
                </span>
                , 54(1), 21-39.
              </li>
              <li>
                Genakos, C., & Pagliero, M. (2022). Competition and
                pass-through: evidence from isolated markets.
                <span className="text9">
                  {" "}
                  American Economic Journal: Applied Economics{" "}
                </span>
                , 14(4), 35-57.
              </li>
              <li>
                {" "}
                Farkas, R., & Yontcheva, B. (2019). Price transmission
                in the presence of a vertically integrated dominant
                firm: Evidence from the gasoline market.
                <span className="text9"> Energy policy </span>, 126, 223-237.
              </li>
              <li>
                Farkas, R., & Czigány, G. (2017). Az autópályák indirekt
                hatása a kiskereskedelmi benzinárakra.
                <span className="text9"> STATISZTIKAI SZEMLE </span>, 95(3),
                278-296.
              </li>
            </ul>
          </div>
        </ShowMoreText>
      </Card.Body>
    </Card>
    );
};
// End: Component code

export default PreviousCard2;
